import axiosInstance from "./axiosInstance";


export const FAQService = {
    getInfo() {
        return axiosInstance.get(`api/faqs`).then(res => res.data);
    },
}